import React from 'react'
import { Flex, Box, Heading, Text, Button, Image } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { get } from 'lodash'

import { getDashboardCreateUserURL } from '../../../utils/cta-utils'
import theme from '../../../lib/theme'

const RealTimeSection = () => {
  const { t } = useTranslation('liveblog')
  const images = useStaticQuery(graphql`
    query {
      real: file(relativePath: { eq: "products/liveblog/real_time.png" }) {
        publicURL
      }
    }
  `)

  const real = get(images, 'real.publicURL')

  return (
    <Flex
      as="section"
      flexDirection={['column', 'column', 'row']}
      alignItems={['center', 'center', 'center']}
      justifyContent={['center', 'center', 'space-between']}
      maxWidth="container"
      width={1}
      mx="auto"
      pt={[20, 10]}
      px={[5, 5, 0]}
      pb={[10, 10, 0]}
    >
      <Box
        maxWidth={['auto', '800px', '512px']}
        width={1}
        mr={[0, 0, 20]}
        textAlign={['left', 'center', 'left']}
      >
        <Heading
          mb={8}
          variant="level2"
          fontSize={theme.customFontsize(36, 45)}
          lineHeight="122%"
          letterSpacing="-0.5px"
        >
          {t('real_time.title')}
        </Heading>

        <Text mx={['auto', 0, 0]} mb={8} variant="level5">
          {t('real_time.subtitle')}
        </Text>

        <Link to={getDashboardCreateUserURL()}>
          <Button variant="primary" width={[1, '160px']} mr={[0, 4, 4]} mb={[15, 15, 0]}>
            {t('buttons.try_it_now')}
          </Button>
        </Link>
      </Box>

      <Box maxWidth="460px" width={1} mb={[5, 10, 0]}>
        <Image src={real} />
      </Box>
    </Flex>
  )
}

export default RealTimeSection
